import React, { Component } from 'react';
import Search from "../util/Search";
import Artist from '../util/Artist';
import Track from '../util/Track';
const API_URI = "https://spotify-api-wrapper.appspot.com";

export default class Music extends Component {
    state = {
        artist: "",
        tracks: [],
    };
    componentWillMount(){
        this.searchArtist("Sonu Nigam");
    }
    searchArtist = (artistQuery) => { 
        fetch(`${API_URI}/artist/${artistQuery}`)
        .then(response => response.json())
        .then(result => {
            console.log(result);
            if(result.artists.total > 0){
                const artist= result.artists.items[0];
                                    // artist: artist,
                    // if both sides are same, can write only once like below
                this.setState({
                    artist
                });
                //logic for fetching tracks
                fetch(`${API_URI}/artist/${artist.id}/top-tracks`)
                .then((response) => response.json())
                .then((result) => {
                    console.log("result tracks", result.tracks);
                    this.setState({
                        tracks: result.tracks,
                    });
                })
                .catch((err) => console.log(err));
                //end tracks logic
            }
        })
        .catch(err => console.log(err));
    }
    render() {
        return (
            <div className="container">
                <div className="row">
                    <div className="col-md-12 jumbotron text-center">
                        <h3>Spotify API Powered Music Player</h3>
                    </div>
                </div>
                <Search search={this.searchArtist}/>
                <Artist artist={this.state.artist}/>
                <Track tracks={this.state.tracks}/>
            </div>
        );
    }
}
